<template>
	<div>
		<small
			class="validation form-text text-danger"
			v-if="errors.length > 0"
			v-for="(error, index) in errors"
			:key="index"
			>{{ error }}</small
		>
	</div>
</template>

<script>
export default {
	name: 'Validation',
	props: ['v'],
	computed: {
		errors() {
			// tslint:disable-next-line
			let errors = [];

			if (this.v === undefined || this.v === null) {
				return errors;
			}

			if (this.v.$error === false) {
				return errors;
			}

			if (Object.keys(this.v).length <= 0) {
				return '';
			}

			if (Object.keys(this.v).includes('required') && !this.v.required) {
				errors.push('The field is required.');
			}

			if (Object.keys(this.v).includes('requiredIf') && !this.v.requiredIf) {
				errors.push('The field is required.');
			}

			if (Object.keys(this.v).includes('minLength') && !this.v.minLength) {
				errors.push(
					'Field must have at least ' + this.v.$params.minLength.min + ' letters.',
				);
			}

			if (Object.keys(this.v).includes('maxLength') && !this.v.maxLength) {
				errors.push(
					'Field must not have more than ' +
						this.v.$params.maxLength.max +
						' letters.',
				);
			}

			if (Object.keys(this.v).includes('email') && !this.v.email) {
				errors.push('Field must have a valid email.');
			}

			if (Object.keys(this.v).includes('between') && !this.v.between) {
				errors.push(
					'Must be between ' +
						this.v.$params.between.min +
						' and ' +
						this.v.$params.between.max +
						'.',
				);
			}

			if (Object.keys(this.v).includes('numeric') && !this.v.numeric) {
				errors.push('Field must only contain numbers.');
			}

			if (Object.keys(this.v).includes('alpha') && !this.v.alpha) {
				errors.push('Field must only contain the alphabet.');
			}

			if (Object.keys(this.v).includes('alphaNum') && !this.v.alphaNum) {
				errors.push('Field must only contain the alphabet and numbers.');
			}

			if (Object.keys(this.v).includes('sameAsPassword') && !this.v.alphaNum) {
				errors.push('Please make sure your passwords match.');
			}

			if (Object.keys(this.v).includes('sameAsEmail')) {
				errors.push('Please make sure your emails match.');
			}

			if (Object.keys(this.v).includes('noUppercase') && this.v.noUppercase) {
				errors.push('Please remove any uppercase letters');
			}

			if (Object.keys(this.v).includes('hasUppercase') && !this.v.hasUppercase) {
				errors.push('Please include an uppercase letter');
			}

			if (Object.keys(this.v).includes('hasLowercase') && !this.v.hasLowercase) {
				errors.push('Please include a lowercase letter');
			}

			return errors;
		},
	},
};
</script>
